export default __webpack_public_path__ + "5510575676c86a640e44a81d2d4a371e.svg";